import ReportCard from '../../../components/reportCard/ReportCard';
import usePageView from '../../../hooks/analytics/usePageView.js';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import verifyToken from "../../../utils/tokenUtils.js";
import { config } from "../../../config/Constants.js";
import  { useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import './reportlanding.css';
import Axios from 'axios';

const ReportLanding = () => {
  usePageView()
  const navigate = useNavigate();
  const [report, setReport] = useState([]);
  const [loading, setLoading] = useState(true);

  const reportCategory = useMemo(() => (
    [...new Map(report.map(obj => [obj.PARENT_NAME, obj])).values()]
  ), [report]);

  useEffect(() => {
    const token = Cookies.get('gtms-cp-auth');;
    token ? verifyToken(token) : navigate('/');
    getReports();
  }, []);

  const getReports = async () => {
    try {
      const customerName = Cookies.get('cp-un');
      const { data } = await Axios.get(config.url.GET_REPORTS, { params: { customerName }});
      setReport(Array.isArray(data?.reports) ? data.reports : []);
    } finally {
      setLoading(false);
    }
  }

  const handleClick = async (report, data) => {
    navigate(`/reportslanding/${report.PARENT_NAME.toLowerCase()}`, { state: data }); 
  }

  return (
    <div className='LandingPage'>
      <div className="LandingPageContainer">
        <NavBar/>
        <Sidebar/>
        <div className="trackingLandingpageContent">
          <div className="reportLandingTitle">
            <h1>Reports Hub</h1>
          </div>
          <div className="reportLandingReports">
            {loading ? null : (
              reportCategory.length ? (
                reportCategory.map(rc => (
                  <ReportCard
                    key={rc.PARENT_ID}
                    title={rc.PARENT_NAME}
                    onClick={() => handleClick(rc, report)}
                  />
                ))
              ) : (
                <p>No reports available.</p>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ReportLanding